import { render, staticRenderFns } from "./ProductsDetailSkeleton.vue?vue&type=template&id=3a7bd2a4&scoped=true"
import script from "./ProductsDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductsDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetailSkeleton.vue?vue&type=style&index=0&id=3a7bd2a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7bd2a4",
  null
  
)

export default component.exports